import { c, nextAppRouter, s } from '../../../../val.config';

export const schema = s.object({
  formSuccessTitle: s.string(),
  formSuccessText: s.string(),
  backButton: s.object({
    text: s.string(),
    href: s.route(),
  }),
});

export default c.define(
  '/app/(main)/kaffeprat/takk/page.val.ts',
  s.router(nextAppRouter, schema),
  {
    '/kaffeprat/takk': {
      formSuccessTitle: `Takker!`,
      formSuccessText: `Vi har mottatt det vi trenger. Du hører fra oss når vi får lest litt og kikket i kalenderen.`,
      backButton: {
        text: 'Tilbake',
        href: '/jobb',
      },
    },
  }
);
